import React from 'react';
import { MDBDataTableV5 } from 'mdbreact';
import { Button,
    Header,
    Segment,
    Icon,
    Divider } from 'semantic-ui-react';

import { FaStore } from 'react-icons/fa';

export default function CardTable(props) {
    const {
        type,
        data,
        tableTitle,
        elementsName,
        isLoadingData,
        lastUpdate,
        updateData } = props;


    function update() {
        updateData();
    }

    const returnIcon = (type) => {
        switch (type) {
            case 'user':
                return (
                    <Icon style={{marginLeft: '15px'}} name='user' />
                );

            case 'store':
                return (
                    <FaStore style={{margin: '0 5px 0 5px'}} />
                );

            case 'routes':
                return (
                    <Icon style={{marginLeft: '15px'}} name='map signs' />
                );

            case 'owntProd':
                return (
                    <Icon style={{marginLeft: '15px'}} name='coffee' />
                );

            case 'comptProd':
                return (
                    <Icon style={{marginLeft: '15px'}} name='coffee' />
                );

            case 'visit':
                return (
                    <Icon style={{marginLeft: '15px'}} name='check' />
                );

            default:
                break;
        }
    }

    return (
        <Segment
            loading={isLoadingData}
            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
            >
            <Header as='h3' floated='left'>
                {tableTitle}
            </Header>
            <Button
                //style={{margin: '-3px'}}
                primary
                size="mini"
                floated='right'
                onClick={update}>
                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                        <Icon name='refresh'/> Atualizar
                    </div>
            </Button>

            <Divider clearing />
            <MDBDataTableV5
                //style={{overflow: 'scroll', fontSize: '10px'}}
                barReverse={true}
                fullPagination={true}
                //displayEntries={false}
                //fixed
                //order={['id', 'desc']}
                maxHeight="100%"
                //scrollX
                //responsive
                responsiveXl
                small
                borderless={true}
                entries={20}
                entriesOptions={[ 20, 30, 50 ]}
                //infoLabel={["", "a", "de", ""]}
                entriesLabel={"Elementos por página"}
                searchLabel="Pesquisar"
                searchTop
                searchBottom={false}
                data={data}
            />
            <Segment.Inline style={{fontSize: '12px', color: '#b0b0b0', marginRight: '10px'}}>
                <Icon name='clock outline' />Atualizado em {lastUpdate}
                {returnIcon(type)}{data ? data['rows'].length : '0'} {elementsName}
            </Segment.Inline>
        </Segment>
    );
}
